'use client';

import { usePathname } from 'next/navigation';
import React, { useEffect } from 'react';
import { Hero400Error } from '@/components/400';
import { AdUnitContext } from '@/tracking/ads/components/AdUnitContext';
import { HeaderNav, HeaderNavCurLink } from '@/components/common/HeaderNav';
import { Footer } from '@/components/blocks/Footer';
import { AnalyticsContext } from '@/tracking/analytics';
import { Diagnostics } from '@/util/diagnostics';

// Rendered inside an App Router page when its props fail an integrity check,
// so it cannot set its own <head> tags — the route's generateMetadata already
// ran and owns them. The visitor keeps the page's normal title and sees the
// error body.
export const DEBUG_TAG = '400-page';
export const TEMPLATE_ID = '1.2';
export const TEMPLATE_NAME = '400 Page';

export default function IntegrityError() {
  const pathname = usePathname() ?? '';

  useEffect(() => {
    Diagnostics.error({ tag: DEBUG_TAG, message: 'Page Error', data: { url: global.location?.href, route: pathname } });
  }, [pathname]);

  return (
    <AnalyticsContext templateId={TEMPLATE_ID} templateName={TEMPLATE_NAME}>
      <AdUnitContext
        adType="other"
        adTKey="error"
      >
        <div style={{ background: '#f4f5f5' }}>
          <HeaderNav current={HeaderNavCurLink.MAIN} />
          <Hero400Error />
          <Footer />
        </div>
      </AdUnitContext>
    </AnalyticsContext>
  );
}
